var _rect, _path, _path2, _path3, _path4, _path5, _g, _path6, _g2, _path7, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodeJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 272,
    height: 101,
    viewBox: "0 0 272 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 271,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_60657)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.504 70.0005C135.294 70.0005 135.085 69.9454 134.901 69.8393L132.979 68.7027C132.692 68.5423 132.832 68.4856 132.927 68.4529C133.309 68.319 133.387 68.2888 133.795 68.0571C133.838 68.0326 133.894 68.0412 133.938 68.0671L135.415 68.9423C135.468 68.9711 135.544 68.9711 135.593 68.9423L141.349 65.6229C141.403 65.5926 141.437 65.5307 141.437 65.4674V58.8313C141.437 58.7651 141.403 58.7061 141.348 58.673L135.594 55.3564C135.541 55.3247 135.47 55.3247 135.417 55.3564L129.664 58.673C129.608 58.7047 129.573 58.7666 129.573 58.8299V65.466C129.573 65.5293 129.608 65.5898 129.662 65.62L131.239 66.5298C132.095 66.9573 132.618 66.4535 132.618 65.9468V59.3971C132.618 59.3035 132.691 59.2315 132.785 59.2315H133.514C133.605 59.2315 133.68 59.3035 133.68 59.3971V65.9496C133.68 67.0897 133.057 67.7447 131.975 67.7447C131.642 67.7447 131.38 67.7447 130.648 67.3848L129.138 66.5154C128.765 66.2994 128.534 65.8964 128.534 65.466V58.8299C128.534 58.398 128.765 57.995 129.138 57.7819L134.9 54.461C135.264 54.2552 135.749 54.2552 136.11 54.461L141.865 57.7834C142.237 57.9979 142.469 58.3995 142.469 58.8313V65.4674C142.469 65.8978 142.237 66.2994 141.865 66.5154L136.11 69.8363C135.926 69.9428 135.717 69.9975 135.504 69.9975",
    fill: "#689F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.282 65.4278C134.764 65.4278 134.236 64.2728 134.236 63.304C134.236 63.2119 134.31 63.1384 134.402 63.1384H135.146C135.228 63.1384 135.297 63.1982 135.31 63.2792C135.422 64.0361 135.757 64.4179 137.28 64.4179C138.493 64.4179 139.009 64.1441 139.009 63.5013C139.009 63.1314 138.862 62.8564 136.977 62.6722C135.401 62.5167 134.427 62.1698 134.427 60.9102C134.427 59.75 135.407 59.0591 137.048 59.0591C138.891 59.0591 139.804 59.6982 139.919 61.0715C139.924 61.119 139.906 61.165 139.875 61.1996C139.843 61.2327 139.798 61.2528 139.752 61.2528H139.004C138.927 61.2528 138.859 61.1981 138.843 61.1233C138.663 60.3273 138.228 60.0725 137.045 60.0725C135.721 60.0725 135.567 60.5331 135.567 60.8786C135.567 61.2975 135.748 61.4198 137.535 61.6559C139.304 61.8905 140.144 62.2216 140.144 63.4639C140.144 64.7163 139.098 65.4346 137.274 65.4346M144.285 58.3969H144.478C144.637 58.3969 144.667 58.286 144.667 58.2213C144.667 58.0514 144.55 58.0514 144.485 58.0514H144.287L144.285 58.3969ZM144.05 57.8528H144.478C144.625 57.8528 144.913 57.8528 144.913 58.181C144.913 58.4098 144.766 58.4573 144.679 58.4861C144.85 58.4977 144.862 58.6099 144.885 58.7683C144.896 58.8676 144.915 59.0389 144.949 59.0965H144.686C144.679 59.0389 144.638 58.7222 144.638 58.7049C144.621 58.6344 144.596 58.5999 144.509 58.5999H144.291V59.0979H144.05V57.8528ZM143.536 58.4717C143.536 58.9871 143.952 59.4045 144.464 59.4045C144.98 59.4045 145.396 58.9784 145.396 58.4717C145.396 57.955 144.974 57.5447 144.462 57.5447C143.958 57.5447 143.535 57.9492 143.535 58.4703M145.575 58.4746C145.575 59.085 145.075 59.583 144.465 59.583C143.86 59.583 143.356 59.0907 143.356 58.4746C143.356 57.847 143.872 57.3662 144.465 57.3662C145.063 57.3662 145.573 57.8484 145.573 58.4746",
    fill: "#689F63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.679 44.0346C117.679 43.7697 117.539 43.5265 117.31 43.3947L111.208 39.8867C111.104 39.8262 110.989 39.7946 110.872 39.7902H110.809C110.692 39.7946 110.577 39.8262 110.472 39.8867L104.369 43.3947C104.142 43.5272 104 43.7704 104 44.0353L104.013 53.4842C104.013 53.6152 104.081 53.7375 104.196 53.8023C104.309 53.8714 104.45 53.8714 104.562 53.8023L108.19 51.7265C108.42 51.5904 108.559 51.3497 108.559 51.0874V46.6732C108.559 46.4098 108.699 46.1665 108.927 46.0355L110.472 45.1467C110.587 45.0805 110.713 45.0477 110.841 45.0477C110.967 45.0477 111.096 45.0802 111.208 45.1466L112.751 46.0351C112.98 46.1661 113.12 46.4093 113.12 46.6728V51.0867C113.12 51.3487 113.262 51.5905 113.49 51.7258L117.116 53.8001C117.229 53.8678 117.371 53.8678 117.484 53.8001C117.596 53.7353 117.667 53.613 117.667 53.482L117.679 44.0346ZM146.477 48.9542C146.477 49.02 146.442 49.0809 146.385 49.1134L144.289 50.3206C144.232 50.3533 144.162 50.3533 144.105 50.3206L142.008 49.1134C141.951 49.0807 141.916 49.0199 141.916 48.9542V46.5364C141.916 46.4705 141.951 46.4098 142.007 46.3767L144.102 45.1675C144.16 45.1344 144.23 45.1344 144.288 45.1675L146.384 46.3767C146.442 46.4098 146.477 46.4705 146.477 46.5364L146.477 48.9542ZM147.044 31.0466C146.929 30.983 146.79 30.9847 146.677 31.0505C146.565 31.1167 146.495 31.2376 146.495 31.3686V40.7253C146.495 40.8175 146.446 40.9024 146.366 40.9485C146.287 40.9945 146.188 40.9945 146.108 40.9485L144.58 40.0688C144.352 39.9372 144.072 39.9372 143.843 40.0688L137.738 43.5888C137.51 43.7198 137.369 43.9631 137.369 44.225V51.267C137.369 51.5305 137.51 51.7723 137.738 51.9047L143.843 55.4272C144.071 55.5582 144.352 55.5582 144.58 55.4272L150.685 51.9033C150.913 51.7709 151.054 51.529 151.054 51.2656V33.7153C151.054 33.4481 150.909 33.2024 150.675 33.0718L147.044 31.0466ZM167.373 46.4728C167.6 46.3412 167.74 46.0983 167.74 45.8363V44.1296C167.74 43.867 167.6 43.6248 167.373 43.4926L161.307 39.9745C161.077 39.8421 160.797 39.8421 160.567 39.9745L154.464 43.4941C154.235 43.6265 154.095 43.8683 154.095 44.1318V51.1709C154.095 51.4358 154.238 51.6805 154.467 51.8115L160.531 55.2648C160.755 55.3929 161.028 55.3944 161.255 55.2691L164.923 53.2322C165.038 53.1675 165.112 53.0451 165.112 52.9127C165.112 52.7802 165.041 52.6564 164.926 52.5917L158.785 49.0707C158.67 49.0059 158.599 48.8835 158.599 48.7525V46.5444C158.599 46.4125 158.668 46.291 158.784 46.2254L160.694 45.1241C160.808 45.0579 160.948 45.0579 161.062 45.1241L162.974 46.2254C163.087 46.2901 163.158 46.4125 163.158 46.5435V48.2795C163.158 48.4105 163.229 48.5329 163.343 48.5991C163.456 48.6639 163.598 48.6639 163.711 48.5976L167.373 46.4728Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.848 46.1431C160.891 46.1177 160.945 46.1177 160.989 46.1431L162.16 46.8183C162.204 46.8436 162.231 46.8902 162.231 46.9406V48.2923C162.231 48.3427 162.204 48.3893 162.16 48.4147L160.989 49.0898C160.945 49.1153 160.891 49.1153 160.848 49.0898L159.677 48.4147C159.632 48.3893 159.605 48.3427 159.605 48.2923V46.9406C159.605 46.8902 159.631 46.8436 159.676 46.8183L160.848 46.1431Z",
    fill: "#689F63"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1909_60657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 39,
    width: 15,
    height: 17
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M127.158 40.009L121.088 43.5094C120.86 43.6404 120.721 43.8823 120.721 44.1437V51.1494C120.721 51.411 120.86 51.6527 121.088 51.7837L127.159 55.2868C127.386 55.4174 127.665 55.4174 127.892 55.2868L133.962 51.7837C134.188 51.6527 134.328 51.4108 134.328 51.1494V44.1437C134.328 43.8823 134.188 43.6404 133.96 43.5094L127.891 40.009C127.778 39.9438 127.651 39.9111 127.524 39.9111C127.397 39.9111 127.27 39.9438 127.157 40.009",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1909_60657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M140.462 42.9155L123.357 34.5391L114.586 52.4138L131.691 60.7907L140.462 42.9155Z",
    fill: "url(#paint0_linear_1909_60657)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1909_60657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 120,
    y: 39,
    width: 15,
    height: 17
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M120.872 51.595C120.93 51.6703 121.002 51.7355 121.088 51.7844L126.295 54.7894L127.162 55.2874C127.292 55.3623 127.44 55.3939 127.585 55.3832C127.634 55.3793 127.682 55.3702 127.729 55.3568L134.132 43.6451C134.083 43.5918 134.025 43.5472 133.961 43.5098L129.986 41.2166L127.885 40.0089C127.825 39.9744 127.761 39.9499 127.695 39.9326L120.872 51.595Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1909_60657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.476 45.3934L125.554 61.7249L141.527 49.9346L129.449 33.6035L113.476 45.3934Z",
    fill: "url(#paint1_linear_1909_60657)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1909_60657",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 121,
    y: 39,
    width: 14,
    height: 17
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M127.452 39.9158C127.35 39.9259 127.25 39.9576 127.158 40.0097L121.105 43.5L127.632 55.3773C127.723 55.3643 127.812 55.3341 127.893 55.2875L133.964 51.7843C134.151 51.6758 134.279 51.4921 134.318 51.2839L127.664 39.9278C127.615 39.9181 127.566 39.9131 127.516 39.9131C127.495 39.9131 127.475 39.9141 127.455 39.916",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1909_60657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.105 39.9131V55.3776H134.315V39.9131H121.105Z",
    fill: "url(#paint2_linear_1909_60657)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1909_60657",
    x1: 131.904,
    y1: 38.7141,
    x2: 123.148,
    y2: 56.5943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#3E863D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#55934F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5AAD45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1909_60657",
    x1: 119.587,
    y1: 53.6528,
    x2: 135.551,
    y2: 41.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#3E863D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#619857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76AC64"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1909_60657",
    x1: 121.109,
    y1: 47.6458,
    x2: 134.318,
    y2: 47.6458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#6BBF47"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#79B461"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#75AC64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#659E5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#3E863D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_60657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 63.7398,
    height: 39.0001,
    fill: "white",
    transform: "translate(104 31)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodeJs);
export default __webpack_public_path__ + "static/media/NodeJS.c16cb24b12219e7e885236b2099e084d.svg";
export { ForwardRef as ReactComponent };